<template>
  <LRX75Hero>
    <template v-slot:header>Pool sharks & greedy cheaters</template>
    <template v-slot:image
      ><img src="https://www.flaticon.com/svg/static/icons/svg/1933/1933218.svg"
    /></template>
    A pool shark is somebody who cheats or distracts players, in pool. Pool sharks often take advantage of the weaknesses of other players.
    This can be applied to other areas as well, such as a lawyer who is aggressive in their legal work.
  </LRX75Hero>
</template>

<script>
import LRX75Hero from "@/components/LRX75Hero.vue";

export default {
  name: "3PoolSharks",
  components: {
    LRX75Hero
  }
};
</script>
